export default __webpack_public_path__ + "static/media/banco12.1bc03e63.png";